import React, { createContext, useMemo, useState } from 'react';
export var searchContext = createContext({
    searchText: '',
    setSearchText: null,
    unifiedResults: [],
    setUnifiedResults: null,
});
var SearchProvider = function (_a) {
    var children = _a.children, _b = _a.unifiedResults, initialUnifiedResults = _b === void 0 ? [] : _b;
    var _c = useState(''), searchText = _c[0], setSearchText = _c[1];
    var _d = useState(initialUnifiedResults), unifiedResults = _d[0], setUnifiedResults = _d[1];
    var value = useMemo(function () { return ({
        searchText: searchText,
        setSearchText: setSearchText,
        unifiedResults: unifiedResults,
        setUnifiedResults: setUnifiedResults,
    }); }, [searchText, unifiedResults]);
    return (React.createElement(searchContext.Provider, { value: value }, children));
};
export default SearchProvider;
